export const FORWARDING_LINK = {
  google:
    'https://knowledge.workspace.google.com/kb/how-to-create-a-forwarding-rule-000009172',
  microsoft:
    'https://learn.microsoft.com/en-us/exchange/recipients-in-exchange-online/manage-user-mailboxes/configure-email-forwarding',
};

export const MX_PROVIDERS = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
  NOT_FOUND: 'not_found',
  UNKNOWN: 'unknown',
  MAILGUN: 'mailgun',
};

export const VERIFICATION_STATUS = {
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
};
